namespace Solovis.Reports.ReportDefinitionCache {

    // NOTE: Set to true to enable logging on ReportDefinitionCache.
    export var _log: boolean = false;

    export var _disableCache: boolean = (Solovis as any).Info.devMode;


    export function _getCacheKey(reportRef) {
        var cacheKey = "Solovis.Reports.ReportDefinitionCache::";

        if (!reportRef) {
            return null;
        }
        else if (reportRef.code) {
            cacheKey += "code=" + reportRef.code;
        }
        else if (reportRef.alias) {
            cacheKey += "alias=" + reportRef.alias;
            return null;
        }
        else if (reportRef.path) {
            cacheKey += "path=" + reportRef.path;
        }
        else {
            return null;
        }

        return cacheKey;
    }


    export function tryGetCachedReportDefinition(reportRef, portalServices?: Solovis.Portal.IPortalServices) {
        if (ReportDefinitionCache._disableCache) {
            return null;
        }

        if (portalServices && portalServices.isProxiedDataEnvironment()) {
            // Report definition caching is not supported for proxied environments. We would have to update
            //   cache key retrieval below to isolate the data environments.
            return null;
        }

        if (typeof Storage === "undefined") {
            return null;
        }

        try {
            var cacheKey = ReportDefinitionCache._getCacheKey(reportRef);
            if (!cacheKey) {
                return null;
            }

            var cachedDefDataJson = window.localStorage.getItem(cacheKey);
            if (cachedDefDataJson) {
                var cachedDefData = JSON.parse(cachedDefDataJson);
                if (cachedDefData.buildId == (Solovis as any).Info.buildId) {
                    if (ReportDefinitionCache._log) { console.log("ReportDefinitionCache.tryGetCachedReportDefinition: using cached report definition: " + cacheKey); }

                    return cachedDefData.reportDefinition;
                }
            }
        }
        catch (ex) {
            console.log("ReportDefinitionCache.tryGetCachedReportDefinition: loading cached report definition failed.");
            console.log(ex);
            return null;
        }

        return null;
    }


    export function tryToCacheReportDefinition(reportRef, reportDefinition, portalServices?: Solovis.Portal.IPortalServices) {
        if (portalServices && portalServices.isProxiedDataEnvironment()) {
            // Report definition caching is not supported for proxied environments. We would have to update
            //   cache key retrieval below to isolate the data environments.
            return;
        }

        if (typeof Storage === "undefined") {
            return;
        }

        try {
            // We will only cache reports with a path that starts with "/Solovis" because we know that
            // those can only be updated when a new build is released (the buildId will be different if
            // report could have possibly changed).
            if (!reportDefinition || !reportDefinition.path) {
                return;
            }

            if (reportDefinition.path.indexOf("/Solovis/") != 0 || reportDefinition.path === "Solovis") {
                return;
            }

            var cacheKey = ReportDefinitionCache._getCacheKey(reportRef);
            if (!cacheKey) {
                return;
            }

            var cachedDefData = {
                buildId: (Solovis as any).Info.buildId,
                reportDefinition: reportDefinition
            };

            var cachedDefDataJson = JSON.stringify(cachedDefData);
            window.localStorage.setItem(cacheKey, cachedDefDataJson);

            if (ReportDefinitionCache._log) { console.log("ReportDefinitionCache.tryToCacheReportDefinition: cached report definition: " + cacheKey); }
        }
        catch (ex) {
            console.log("ReportDefinitionCache.tryToCacheReportDefinition: saving cached report definition failed.");
            console.log(ex);
        }
    }
}
